import type { TOC } from '@ember/component/template-only';
import { local } from 'embroider-css-modules';

import styles from './drawer-section.module.css';

interface ParityParityManagerDrawerSectionSignature {
  Args: {
    disableBorder?: boolean;
    subtitle?: string;
    title: string;
  };
  Blocks: {
    default: [];
  };
}

const ParityParityManagerDrawerSection = <template>
  <div
    class={{local
      styles
      "drawer-section"
      (unless @disableBorder "drawer-section-with-border-bottom")
    }}
    data-test-id="drawer-section"
  >
    <h3 class={{styles.title}}>{{@title}}</h3>
    {{#if @subtitle}}
      <p class="text-300--regular {{styles.subtitle}}">{{@subtitle}}</p>
    {{/if}}

    {{yield}}
  </div>
</template> satisfies TOC<ParityParityManagerDrawerSectionSignature>;

export default ParityParityManagerDrawerSection;
